import React from 'react';
import { useIntl } from 'react-intl';

import Icon from '../Icon';
import lock from 'assets/svg/lock.svg';
import messages from 'messages';
import './odd.scss';

interface Props {
    stubNode?: JSX.Element;
}

const OddButtonStub: React.FC<Props> = ({ stubNode }) => {
    const { formatMessage } = useIntl();

    return (
        <button
            type="button"
            styleName="button is-disabled"
            className="__app-Odd-button __app-Odd-is-disabled"
            title={formatMessage(messages.deactivated)}
        >
            {stubNode ? (
                stubNode
            ) : (
                <Icon
                    glyph={lock}
                    styleName="lock"
                    className="lock __app-Odd-lock"
                />
            )}
        </button>
    );
};

export default OddButtonStub;
